import { takeLatest, put, call, select } from 'redux-saga/effects';
import getBrowserHistory from 'yoda-core-components/lib/navigation/history/getBrowserHistory';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import { initiateCheckout } from 'yoda-interfaces/lib/Order/OrderApi';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import {
    URL_CHECKOUT_PAYMENT,
    URL_CHECKOUT_SHIPPING,
} from 'yoda-checkout-components/lib/common/Constants';
import { setOrderErrorMessage } from 'yoda-checkout-components/lib/actions/ServiceErrorHandlerAction';
import { stringifyQuery } from 'yoda-core-components/lib/navigation/query/makeQuery';
import { selectContext } from 'yoda-site-components/lib/selectors/ContextSelector';
import {
    ADD_PAYPAL_PAYMENT_TYPE_REQUEST,
    CLEAR_SERVICE_ERROR,
} from '../actionTypes/PaymentActionTypes';
import { CART_DETAILS_GET_REQUEST } from '../actionTypes/CartActionTypes';

function* addPayPalPaymentType(action) {
    const modifyAction = action;
    const { deviceType, isNative } = yield select(selectContext);

    let deviceClientId = '';
    if (isNative && window?.webkit) {
        deviceClientId = 'amNwLmlvczpETndDU1QyZHBi'; // ios App
    } else if (isNative) {
        deviceClientId = 'amNwLmFuZHJvaWQ6UDE2TENncmZjWQ'; // Android App
    } else if (deviceType.isDesktop) {
        deviceClientId = 'amNwOnlvZGF3Ojc1NTU4NTk2';
    } else if (deviceType.isMobile) {
        deviceClientId = 'amNwLnJ3ZG06QVVndFRydFc5cg';
    } else if (deviceType.isTablet) {
        deviceClientId = 'amNwLnJ3ZHQ6Uk5hdVJqdUsycw';
    }

    if (modifyAction?.payload && deviceClientId) {
        modifyAction.payload.clientId = deviceClientId;
    }
    const result = yield call(FactorySaga, initiateCheckout, modifyAction);
    if (result.isSuccess) {
        const getCartDetailsRequst = {
            type: CART_DETAILS_GET_REQUEST,
            payload: {
                pageName: 'review',
            },
        };
        yield put(getCartDetailsRequst);
    } else {
        const checkoutURLConfig = {};
        checkoutURLConfig.pathname = URL_CHECKOUT_SHIPPING;
        checkoutURLConfig.search = stringifyQuery({ from: 'review' });
        const errorCodeResponse = get(result, 'response.data[0].errorCode', '');
        const errorMessageResponse = get(result, 'response.data[0].errorMessage', null);
        if (errorCodeResponse === 'SRV_PAYPAL_TOKEN_NOT_FOUND') {
            const paypalPaymentException = {
                reviewPayment: {
                    errorCode: errorCodeResponse,
                    errorMessage: errorMessageResponse,
                },
            };
            yield put(setOrderErrorMessage(paypalPaymentException));
            checkoutURLConfig.pathname = URL_CHECKOUT_PAYMENT;
            checkoutURLConfig.search = stringifyQuery({ from: 'review' });
        } else if (errorCodeResponse === 'SRV_PRICE_FALLBACK_FAILED') {
            yield put({ type: CLEAR_SERVICE_ERROR });
        } else {
            const errorList = [];
            forEach(result.response.data, (data) => {
                data.errorCode !== 'KEY_EMPTY_DELIVERY_DATE' && errorList.push(data);
            });
            if (errorList.length !== 0) {
                result.response.data = errorList;
            }
        }
        getBrowserHistory().push(checkoutURLConfig);
    }
}

const watchAddPayPalPaymentType = function* watchAddPayPalPaymentType() {
    yield takeLatest(ADD_PAYPAL_PAYMENT_TYPE_REQUEST, addPayPalPaymentType);
};
watchAddPayPalPaymentType.sagaName = 'watchAddPayPalPaymentType';

export default watchAddPayPalPaymentType;
